import React, { useState } from "react";
import RequestService from "../../services/request.service";

import './gestion_usuarios.scss'

import { toast } from 'react-toastify'

import { useParams } from 'react-router-dom'

import { Modal, Button, Tabs, Tab, Table } from 'react-bootstrap'


import AgregarUsuarioModal from './AgregarUsuarioModal'


import Dialog from '../../services/Dialogs'



const GestionSucursal = () => {


    const dialog = new Dialog();


	let { uuid_sucursal } = useParams();


  const skullFormUser = {
  	username : "",
  	iddepartamento : ""
  }

  const [ show_modal_nuevo_usuario , setShowModalNuevoUser ] = useState(false)
  const [ tipo_usuario , setTipo_usuario ] = useState(0)
  const [ nuevo_usuario_form , setNuevoFormUser ] = useState<any>({ ...skullFormUser })

  const onHideModalNuevoUsuario = () =>{
    setShowModalNuevoUser(false)
    cargarPanel()
  }

  const abrirModalNuevoUsuario = (tipo_usuario:number) =>{
  	setNuevoFormUser({ ...skullFormUser })
  	setTipo_usuario(tipo_usuario)
  	setShowModalNuevoUser(true)
  }



	const [ gestion, setGestionData ] = useState<any>( {
		// departamentos : [{
		// 	departamento : "",
			gerentes : [],
			mesa : [],
		// 		asesores : []
		// 	}]
		// }],
		sucursal : {
				    id: 0,
				    nombre_sucursal: "",
				    uuid: "",
				    direccion : "",
				    colonia : "",
				    cp : "",
				    telefono : "",
				    email : "",
				    idestado: {
				      id: 0,
				      estado: "",
				      capital: ""
				    }
				},
	} )


	const cargarPanel = async () =>{
	  try{
	    let response = await RequestService.getEndPoint('sucursal/gestion/usuarios/'+uuid_sucursal)
	    setGestionData(response.data)
	  }
	  catch(e){
	    toast.error('Error al cargar')
	  }
	}

	React.useEffect(() => {
		cargarPanel()
	}, []);


  const eliminarRelacion = async(uuid_asesor:string,uuid_gerente:string)=>{
  	try{
  		if(await dialog.confirm('¿Estas seguro? Este proceso no podrá revertirse',{})){
	  		RequestService.delete('gerentes/eliminar_relacion/'+uuid_asesor+'/'+uuid_gerente)
	  		await cargarPanel()
	  		toast.warning('Se elimino la relación entre el asesor y el gerente. Espero que sepas lo que estás haciendo.')
	  		
  		}
  	}
  	catch(e){
  		toast.error('Erro al eliminar la relación')
  	}
  }



	const [show, setShow] = useState(false);

	const [ usuarios_disponibles, setUsuariosDisponibles ] = useState<any>([])


	// const [ uuid_departamento_add, setDeptoAdd ] = useState("")
	const [ uuid_gerente_add, setGerAdd ] = useState("")
	const [ uuid_asesor_agregar, setUUIDAsesor ] = useState("")

	const handleClose = () => setShow(false);
	const handleShow = async ( uuid_gerente:string) =>{ 
	// setDeptoAdd(uuid_departamento)
  	setGerAdd(uuid_gerente)
  	let response = await RequestService.getEndPoint('asesores_disponibles/'+uuid_sucursal+'/'+uuid_gerente)
  	setUsuariosDisponibles(response.data)
  	setShow(true);
  }


  const agregarAsesor = async () => { 
  	try{
  		if(await dialog.confirm('¿Estás seguro?',{})){
	  		let response = await RequestService.create('asesores_disponibles/agregar',{ uuid_gerente : uuid_gerente_add, uuid_asesor : uuid_asesor_agregar }) 
	  		setShow(false);
	  		cargarPanel()
  		}
  	}
  	catch(e){ 
  		toast.error('Error al agregar este asesor al gerente')
 	}

  }


  const eliminarMesa = async (uuid_usuario) =>{
  	try{
  		if(await dialog.confirm('¿Estás seguro?',{})){
	  		await RequestService.delete('mesa/eliminar/'+uuid_usuario) 
	  		cargarPanel()
  		}
  	}
  	catch(e){ 
  		toast.error('Error al agregar este asesor al gerente')
 	}
  }


	return (
		<>

			<div className="container">

				<h3>
				  {gestion.sucursal.nombre_sucursal} 
				  <small className="text-muted">{gestion.sucursal.uuid}</small>
				</h3>
				<p className="lead">{gestion.sucursal.direccion}, <b>{gestion.sucursal.colonia}</b> {gestion.sucursal.idestado.estado}</p>
				<ul className="list-inline">
				  <li className="list-inline-item"><i className="fa fa-mobile" /> {gestion.sucursal.telefono} </li>
				  <li className="list-inline-item"><i className="fa fa-envelope" /> {gestion.sucursal.email} </li>
				</ul>


				<small>Opciones</small>

				<ul className="list-inline">
				  <li className="list-inline-item"><button onClick={()=>{ abrirModalNuevoUsuario(1) }} className="btn btn-link"><small>Agregar Gerente</small></button></li>
				  <li className="list-inline-item"><button onClick={()=>{ abrirModalNuevoUsuario(3) }} className="btn btn-link"><small>Agregar Asesor</small></button></li>
				  <li className="list-inline-item"><button onClick={()=>{ abrirModalNuevoUsuario(2) }} className="btn btn-link"><small>Agregar Mesa de Control</small></button></li>
				</ul>


				
<Tabs defaultActiveKey="gerentes" className="mb-3">
  <Tab eventKey="gerentes" title="Gerentes y Asesores">





				{
					// JSON.stringify(gestion.gerentes)
				}

  
			  	{
			  		gestion.gerentes.map((gerente:any) =>

			  			 <div key={ Math.random().toString(36).substr(2, 9) } className={' ' + (gerente.activo?'**':'no_activo')} style={{padding:'4px 16px'}}>

			  			 	<small><b>Gerente</b></small>
			  			 	<h5 className="nm"><b>{gerente.nombres}</b> <small>{gerente.paterno} {gerente.materno}</small></h5>	
			  			 	<p style={{fontSize:12}} className="mb-2">{gerente.celular}</p>


			  			 	<small><b>Asesores</b></small>
			  			 	

				  			<div className="row row-cols-4">

				  				{

					  				gerente.asesores.map( asesor =>
					  					<div key={ Math.random().toString(36).substr(2, 9) } className={'col ' + (asesor.activo?'**':'no_activo')}>
					  						<p className="nm"><small><b>{asesor.nombres}</b> {asesor.paterno} {asesor.materno} {}</small></p>	
					  						<p style={{fontSize:10}} className="nm">{asesor.celular}</p>

											<ul className="nav nav-pills">
											  <li className="nav-item">
											    <a className="nav-link cursor" onClick={()=>{eliminarRelacion(asesor.uuid,gerente.uuid)}} style={{padding: '0.3rem 0.5rem',fontSize:10}}>Quitar</a>
											  </li>
											  {
											  	!asesor.activo && (
													  <li className="nav-item">
													    <a className="nav-link disabled" style={{padding: '0.3rem 0.5rem',fontSize:10}} >Deshabilitado</a>
													  </li>
											  	)
											  }

											</ul>

					  					</div>
					  				)
					  			}

				  			</div>

							<ul className="list-inline">
							  <li className="list-inline-item"><button onClick={()=>{ handleShow(gerente.uuid) }} className="btn btn-link"><small>Agregar Asesor</small></button></li>
							</ul>

				  			<hr />

			  			</div>

			  		)
			  	}
    
  
  </Tab>
  <Tab eventKey="profile" title="Mesa de Control">


    {
		gestion.mesa.length > 0 && (

				<>

					<Table striped bordered hover size="sm">
					  <thead>
					    <tr style={{fontSize:10}}>
					      <th>Nombre(s)</th>
					      <th>Apellido Paterno</th>
					      <th>Apellido Materno</th>
					      <th>Usuario</th>
					      <th>Email</th>
					      <th>Departamento</th>
					      <th></th>
					    </tr>
					  </thead>
					  <tbody>


      
				        	{
				        		gestion.mesa.map(usuario =>

								    <tr key={ Math.random().toString(36).substr(2, 9) }>
								      <td className="v" style={{width:'180px'}}><b>{usuario.nombres}</b></td>
								      <td className="v" style={{width:'140px'}}>{usuario.paterno}</td>
								      <td className="v" style={{width:'140px'}}>{usuario.materno}</td>
								      <td className="v" style={{width:'150px'}}><small><b>{usuario.username}</b></small></td>
								      <td className="v" style={{width:'250px'}}><small>{usuario.email}</small></td>
								      <td className="v"><small>{usuario.departamento}</small></td>
								      <td className="v" style={{width:'40px'}}>
								      	<Button onClick={()=>{eliminarMesa(usuario.uuid)}} variant="link"><i className="fa fa-trash"/></Button>
								      </td>
								    </tr>

				        		)
				        	}




					  </tbody>
					</Table>


					<Button variant="link">Reactivar Usuario de Mesa</Button>

				</>

			)
    }
    {
		gestion.mesa.length === 0 && (

				<>
					<i className="fa fa-warning" /> No tienes usuarios de Mesa de Control
				</>


			)
    }

  </Tab>
</Tabs>



				
			</div>




			<AgregarUsuarioModal show={show_modal_nuevo_usuario} tipo_usuario={tipo_usuario} uuid_sucursal={uuid_sucursal} nuevo_usuario_form={nuevo_usuario_form} handleClose={onHideModalNuevoUsuario} />





      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Agregar Asesor</Modal.Title>
        </Modal.Header>
        <Modal.Body>

        		{
        			usuarios_disponibles.length == 0 && (
        					<p><i className="fa fa-warning" /> No puedes agregar un Asesor porque todos están asignados a sus respectivos Gerentes.</p>
        				)
        		}


        		{
        			usuarios_disponibles.length > 0 && (


			        <div className="mb-3">
			            <label className="form-label d-block">Asesores Disponible</label>

				        	{
				        		usuarios_disponibles.map(usuario =>

							            <div key={ Math.random().toString(36).substr(2, 9) } className="form-check">
							                <input className="form-check-input" id={usuario.uuid} type="radio" name="asesoresDisponible" value={usuario.uuid} onChange={(event)=>{ setUUIDAsesor(event.target.value) }} />
							                <label className="form-check-label" htmlFor={usuario.uuid}>
							                	<p className="nm">
							                		<b>{usuario.nombres}</b> {usuario.paterno} {usuario.materno}
							                	</p>
							                	<small>{usuario.celular}</small>
							                </label>
							            </div>

				        		)
				        	}

			        </div>

        			)
        		}


        </Modal.Body>
        		{
        			usuarios_disponibles.length > 0 && (


        <Modal.Footer>
          <Button variant="warning" onClick={handleClose}>
            Cerrar
          </Button>
          <Button variant="success" onClick={()=>{agregarAsesor()}} disabled={uuid_asesor_agregar===""}>Agregar Asesoressor</Button>
        </Modal.Footer>


        		)
        	}

      </Modal>






		</>
	)


}

export default GestionSucursal